/**
 * Horizon Pro — Dismissible Announcement Bar
 * Adds close button functionality to the announcement bar.
 * Stores dismissal in sessionStorage or localStorage based on setting.
 */
(function () {
  const bar = document.querySelector('.announcement-bar-component, [class*="announcement-bar"]');
  if (!bar) return;

  const closeBtn = bar.querySelector('.hp-announcement-close');
  if (!closeBtn) return;

  const sectionId = bar.closest('.shopify-section')?.id || 'announcement';
  const storageKey = 'hp-dismissed-' + sectionId;
  const duration = closeBtn.dataset.dismissDuration || 'session';
  const storage = duration === 'permanent' ? localStorage : sessionStorage;

  // Check if already dismissed
  if (storage.getItem(storageKey) === '1') {
    const section = bar.closest('.shopify-section');
    if (section) section.style.display = 'none';
    return;
  }

  closeBtn.addEventListener('click', function () {
    storage.setItem(storageKey, '1');
    const section = bar.closest('.shopify-section');
    if (section) {
      section.style.transition = 'opacity 0.3s, max-height 0.3s';
      section.style.opacity = '0';
      section.style.maxHeight = section.offsetHeight + 'px';
      requestAnimationFrame(function () {
        section.style.maxHeight = '0';
        section.style.overflow = 'hidden';
      });
      setTimeout(function () {
        section.style.display = 'none';
      }, 300);
    }
  });
})();
